app.ReportScheduleList = app.AbstractCollection.extend({
  model: app.ReportSchedule,

  url() {
    return '/api/v2/reporting/report-schedules';
  },
});
